import { SVGProps } from 'react';
const SvgSortAscending = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 17h6M4 12h9M18 11v8M21 16l-3 3-3-3M4 7h12"
    />
  </svg>
);
export default SvgSortAscending;
